"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyObjsWithUID = void 0;
function makeEmptyObjsWithUID() {
    return {
        id: '',
        data: {},
    };
}
exports.makeEmptyObjsWithUID = makeEmptyObjsWithUID;
//# sourceMappingURL=ObjsWithUID.js.map